import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import consts from '../../utils/consts';
import SaveSplitButton from './SaveSplitButton';
import { pushTableData, pushRunUrl, pushRequestBody, pushHideCard, showDialogWin, showSnackEnable, pushIsSaveDisabled, showTostLoader, pushIsSaveAsPopUp, showContextualPath, setIsEntityChanged, setIsRelatedEntityChanged } from '../../slices/customQueryHeaderSlice';
import { pushShowCard, pushShowTable, pushSetLoaderComp, pushTableCols, pushCheckTableData, pushTableHeadCols, pushAddCriteriaCard, isFilterCleared, applyingNewFilter } from '../../slices/customQueryBodySlice';
import accordianDown from '../../assets/img/accordian-down.svg';
import accordianUp from '../../assets/img/accordian-up.svg';
import { getPostResponseAPIData, getPutResponseAPIData } from '../../services/apiService';
import { StyledButtonGroup, StyledButtonRun, StyledSpan } from './RunAndSaveStyle';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
import DialogModal from '../../components/DialogModal/DialogModal';
import { parseQueryResults } from '../../utils/utils';
import RunIcon from '../../components/RunIcon/RunIcon';

const RunAndSave = () => {
  const [buttonValue, setButtonValue] = useState('');
  const selectedChipArray = useSelector(state => state.customQueryBody.ChipArrayAddCriteria);
  const resultsCols = useSelector(state => state.customQueryBody.columns) || [];
  const tableHeadCols = useSelector(state => state.customQueryBody.tableColumns) || [];
  const isEntityChanged = useSelector(state => state.customQueryHeader.isEntityChanged);
  const isRelatedEntityChanged = useSelector(state => state.customQueryHeader.isRelatedEntityChanged);
  const accordianKeyItems = useSelector(state => state.entityCard.accordionKeyItems);
  const selectedDataType = useSelector(state => state.customQueryHeader.selectedDataType);
  const isSaveDisabled = useSelector(state => state.customQueryHeader.isSaveDisabled);
  const hideCard = useSelector(state => state.customQueryHeader.hideCard);
  const selectedRelatedDataType = useSelector(state => state.customQueryHeader.relatedDataButton);
  const relRequestBody = useSelector(state => state.customQueryHeader.relRequestBody);
  const showCriteriaCard = useSelector(state => state.customQueryBody.showCriteriaCard);
  const apiResponseData = useSelector(state => state.customQueryHeader.run);
  const queryData = useSelector(state => state.queriesManager.queryData);
  const {
    operationsNamesArray,
    userAccountOperations,
    baseUrl,
    oprPreValues
  } = consts;
  const dispatch = useDispatch();
  let selectedEntityName = selectedDataType.substring(0, selectedDataType.length - 1);

  const processColumns = (results = []) => {
    let cols = [];

    if (results.length > 0) {
      let keys = Object.keys(results[0]);
      keys = keys.filter(item => item.toLowerCase() !== 'key'); //implement dynamic columns

      keys.forEach(key => {
        let isHidden = key.endsWith('Id'); // Default Ids should be hidden

        cols.push({
          label: startCase(key),
          dataKey: key,
          hidden: isHidden,
          align: 'left',
          Header: startCase(camelCase(key)),
          accessor: key,
          width: key === 'USER' ? 100 : Math.min(400, startCase(camelCase(key)).length * 10)
        });
      });
    }

    const riskFactorArr = cols.filter(eachItem => eachItem.Header.toLowerCase().includes('risk'));
    const filteredArray = cols.filter(eachItem => !eachItem.Header.toLowerCase().includes('risk'));
    filteredArray.splice(6, 0, ...riskFactorArr);
    return filteredArray;
  };

  useEffect(() => {
    let queryResults = {
      data: [],
      totalCount: 0,
      totalPages: 0
    };

    if (apiResponseData) {
      queryResults = parseQueryResults(apiResponseData);
      let tableCols = processColumns(queryResults.data);
      dispatch(pushIsSaveDisabled(false));
      dispatch(pushCheckTableData(true));

      if (isEntityChanged || isRelatedEntityChanged || resultsCols && resultsCols.length === 0) {
        dispatch(pushTableCols(tableCols));
      }

      dispatch(pushShowTable(true));
      dispatch(pushAddCriteriaCard(true));
      dispatch(showContextualPath(false));
      dispatch(pushTableData(queryResults));
      dispatch(pushSetLoaderComp(false));

      if (isEntityChanged || isRelatedEntityChanged || tableHeadCols && tableHeadCols.length === 0) {
        dispatch(pushTableHeadCols(tableCols));
      }

      dispatch(pushIsSaveAsPopUp(false));
      dispatch(setIsEntityChanged(false));
      dispatch(setIsRelatedEntityChanged(false));
    }
  }, [apiResponseData]);

  const processRun = (urlArray, requestBody) => {
    dispatch(getPostResponseAPIData(urlArray, requestBody, 'run'));
  };

  const changeButtonName = value => {
    setButtonValue(value);
  };

  const runQuery = () => {
    let adaRequestBody;
    dispatch(pushShowTable(false));
    dispatch(pushShowCard(false));
    dispatch(pushSetLoaderComp(true));
    adaRequestBody = getRequestBody();
    dispatch(pushRequestBody(adaRequestBody));
    dispatch(isFilterCleared(false));
    dispatch(applyingNewFilter(false));
    let apiUrl = getApiUrl();
    processRun(apiUrl, adaRequestBody);
  };

  function getRequestBody() {
    let requestBody = {};
    let selectedQueryArray = selectedChipArray;
    let operationsArr = operationsNamesArray.concat(userAccountOperations);
    let isObj = {
      accountIdList: [],
      applicationList: [],
      applicationTypeList: [],
      environmentIdList: [],
      environmentNameList: [],
      groupNameList: [],
      permissionNameList: [],
      resourceIdList: [],
      resourceNameList: [],
      resourceTypeList: [],
      roleNameList: [],
      userAccountNameList: [],
      userList: []
    };
    let userAccountObj = '';
    let arr = accordianKeyItems.map(el => el.entityKeys);
    let mergedArray = [].concat.apply([], arr);
    mergedArray = mergedArray.filter(item => item !== 'User Account');
    let keyValueObj = {};
    let keyValName = '';
    mergedArray.forEach(arr => {
      if (arr === 'APPLICATION') {
        keyValName = 'appName';
      } else if (arr === 'APPLICATION_TYPE') {
        keyValName = 'appType';
      } else if (arr === 'ENVIRONMENT_NAME') {
        keyValName = 'environmentName';
      } else if (arr === 'ENVIRONMENT_ID') {
        keyValName = 'environmentId';
      } else if (arr === 'GROUP_NAME') {
        keyValName = 'groupName';
      } else if (arr === 'PERMISSION_NAME') {
        keyValName = 'permissionName';
      } else if (arr === 'SERVICE_RESOURCE_NAME') {
        keyValName = 'resourceName';
      } else if (arr === 'SERVICE_RESOURCE_TYPE') {
        keyValName = 'resourceType';
      } else if (arr === 'ROLE_NAME') {
        keyValName = 'roleName';
      } else if (arr === 'USER_ACCOUNT_NAME') {
        keyValName = 'userAccountName';
      }

      keyValueObj[keyValName] = null;
    });
    let riskObj = {
      riskRange: '',
      riskType: []
    };
    let activity = {
      activityPeriod: '',
      between: ''
    };
    let access = {
      accessDays: '',
      accessType: ''
    };
    requestBody['access'] = access;
    requestBody['activity'] = activity;
    requestBody['risk'] = riskObj;

    for (let i = 0; i < operationsArr.length; i++) {
      let operationKey = operationsArr[i];

      if (operationKey === 'is') {
        requestBody[operationKey] = isObj;
      } else if (operationKey === 'since' || operationKey === 'before' || operationKey === 'on') {
        requestBody[operationKey] = userAccountObj;
      } else {
        requestBody[operationKey] = oprPreValues;
      }
    }

    let keyJson = [];

    for (let tagItem of selectedQueryArray) {
      let selectedOpr = '';

      for (let oprationItem of operationsArr) {
        if (tagItem.indexOf(' contains ') > -1) {
          selectedOpr = 'contains';
          break;
        } else if (tagItem.indexOf(' startsWith ') > -1) {
          selectedOpr = 'startsWith';
          break;
        } else if (tagItem.indexOf(' endsWith ') > -1) {
          selectedOpr = 'endsWith';
          break;
        } else if (tagItem.indexOf(' since ') > -1) {
          selectedOpr = 'since';
          break;
        } else if (tagItem.indexOf(' before ') > -1) {
          selectedOpr = 'before';
          break;
        } else if (tagItem.indexOf(' on ') > -1) {
          selectedOpr = 'on';
          break;
        } else if (tagItem.indexOf(oprationItem) > -1) {
          selectedOpr = oprationItem;
          break;
        } else {
          selectedOpr = oprationItem;
          break;
        }
      }

      let tagStringArray = [];

      if (tagItem.indexOf(selectedOpr) > -1) {
        tagStringArray = tagItem.split(' ' + selectedOpr + ' ');
      }

      let existIndex = keyJson.findIndex(el => el.entityName === tagStringArray[0] && el.entityOpr === selectedOpr);

      if (existIndex > -1 && selectedOpr !== 'is') {
        keyJson[existIndex].entityValue += ', ' + tagStringArray[1];
      } else {
        let obj = {};
        obj['entityName'] = tagStringArray[0];
        obj['entityValue'] = tagStringArray[1];
        obj['entityOpr'] = selectedOpr;
        keyJson.push(obj);
      }
    }

    for (let item of keyJson) {
      let currentEntityOpr = '';

      if (item.entityName === selectedEntityName + ' Risk Type' || item.entityName === selectedEntityName + ' Risk Score') {
        currentEntityOpr = 'risk';
        item.entityOpr = 'risk';
      } else {
        currentEntityOpr = item.entityOpr;
      }

      let selectedOpr = { ...requestBody[currentEntityOpr]
      };

      if (item.entityOpr === 'is') {
        if (item.entityName === 'Application') {
          selectedOpr['applicationList'].push(item.entityValue);
        } else if (item.entityName === 'Application Type') {
          selectedOpr['applicationTypeList'].push(item.entityValue);
        } else if (item.entityName === 'Environment Name') {
          selectedOpr['environmentNameList'].push(item.entityValue);
        } else if (item.entityName === 'Environment Id') {
          selectedOpr['environmentIdList'].push(item.entityValue);
        } else if (item.entityName === 'Group Name') {
          selectedOpr['groupNameList'].push(item.entityValue);
        } else if (item.entityName === 'Permission Name') {
          selectedOpr['permissionNameList'].push(item.entityValue);
        } else if (item.entityName === 'Service Resource Name') {
          selectedOpr['resourceNameList'].push(item.entityValue);
        } else if (item.entityName === 'Service Resource Type') {
          selectedOpr['resourceTypeList'].push(item.entityValue);
        } else if (item.entityName === 'Role Name') {
          selectedOpr['roleNameList'].push(item.entityValue);
        } else if (item.entityName === 'User Account Name') {
          selectedOpr['userAccountNameList'].push(item.entityValue);
        } else if (item.entityName === 'User') {
          selectedOpr['userList'].push(item.entityValue);
        }
      } else if (item.entityOpr === 'since' || item.entityOpr === 'before' || item.entityOpr === 'on') {
        // For User Account
        selectedOpr = item.entityValue;
      } else if (item.entityName === selectedEntityName + ' Risk Type' || item.entityName === selectedEntityName + ' Risk Score') {
        if (item.entityName === selectedEntityName + ' Risk Type') {
          selectedOpr['riskType'].push(item.entityValue);
        } else if (item.entityName === selectedEntityName + ' Risk Score') {
          let scoreString = item.entityValue.split(' to ');
          selectedOpr['riskRange'] = scoreString[0] + ',' + scoreString[1];
        }
      } else {
        let eName = item.entityName;
        let keyValName = '';

        if (eName === 'Application') {
          keyValName = 'appName';
        } else if (eName === 'Application Type') {
          keyValName = 'appType';
        } else if (eName === 'Environment Name') {
          keyValName = 'environmentName';
        } else if (eName === 'Environment Id') {
          keyValName = 'environmentId';
        } else if (eName === 'Group Name') {
          keyValName = 'groupName';
        } else if (eName === 'Permission Name') {
          keyValName = 'permissionName';
        } else if (eName === 'Service Resource Name') {
          keyValName = 'resourceName';
        } else if (eName === 'Service Resource Type') {
          keyValName = 'resourceType';
        } else if (eName === 'Role Name') {
          keyValName = 'roleName';
        } else if (eName === 'User Account Name') {
          keyValName = 'userAccountName';
        } else if (eName === 'User') {
          keyValName = 'user';
        }

        if (Object.prototype.hasOwnProperty.call(requestBody[item.entityOpr], keyValName)) {
          selectedOpr[keyValName] = item.entityValue;
        }
      }

      requestBody[item.entityOpr] = selectedOpr;
    }

    dispatch(pushRequestBody(requestBody));
    return requestBody;
  }

  const getApiUrl = () => {
    let urlArray = [];
    const paginationQueryString = 'limit=10&offset=1';
    let type = '';
    let resurl = '';
    let relatedStrings = [];
    selectedRelatedDataType.forEach(relatedType => {
      if (relatedType === 'User Accounts') {
        relatedStrings.push('userAccount');
      } else {
        relatedStrings.push(relatedType.substring(0, relatedType.length - 1).toLowerCase());
      }
    });

    if (selectedDataType === 'User Accounts') {
      type = 'userAccounts';
    } else {
      type = selectedDataType.toLowerCase();
    }

    resurl = `${type.substring(0, type.length - 1)}&` + (relatedStrings.length > 0 ? `relatedtypes=${relatedStrings.toString()}&` : '');
    let apiUrl = `${baseUrl}${resurl}`;
    dispatch(pushRunUrl(apiUrl));
    urlArray.push(apiUrl + paginationQueryString);
    return urlArray;
  };

  const onSaveQuery = buttonName => {
    setButtonValue(buttonName);
    dispatch(showDialogWin(true));
  };

  const processSave = (formValues, value) => {
    setButtonValue('');
    const queryId = queryData.queryid;
    let requestParams = {};
    let getBaseUrl = '/api/ada/querybuilder/queries';
    let adaRequestBody = relRequestBody;

    if (adaRequestBody === undefined) {
      adaRequestBody = getRequestBody();
    }

    let formedRelatedArr = [];
    selectedRelatedDataType.forEach(eachRelatedEnitity => {
      if (eachRelatedEnitity === 'User Accounts') {
        formedRelatedArr.push('userAccount');
      } else {
        formedRelatedArr.push(eachRelatedEnitity.substring(0, eachRelatedEnitity.length - 1).toLowerCase());
      }
    });
    let entitySaveType = '';

    if (selectedDataType === 'User Accounts') {
      entitySaveType = 'userAccount';
    } else {
      entitySaveType = selectedDataType.substring(0, selectedDataType.length - 1).toLowerCase();
    }

    requestParams = { ...formValues,
      ...{
        adaquery: adaRequestBody
      },
      queryid: 0,
      entityType: entitySaveType,
      relatedEntityType: formedRelatedArr.toString(),
      queryType: 'saved query'
    };
    dispatch(showSnackEnable(false));
    const dateValue = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');

    if (queryId) {
      if (value === 'Save') {
        dispatch(showTostLoader(true));
        dispatch(getPutResponseAPIData([getBaseUrl + `/${queryId}`], { ...requestParams,
          created: '',
          updated: dateValue
        }, 'save'));
      } else {
        dispatch(getPostResponseAPIData([getBaseUrl], { ...requestParams,
          created: dateValue,
          updated: dateValue
        }, 'save'));
      }
    } else {
      dispatch(getPostResponseAPIData([getBaseUrl], { ...requestParams,
        created: dateValue,
        updated: dateValue
      }, 'save'));
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButtonGroup, null, /*#__PURE__*/React.createElement(StyledButtonRun, {
    onClick: runQuery,
    disabled: !selectedDataType || !showCriteriaCard
  }, /*#__PURE__*/React.createElement(RunIcon, {
    className: "fas fa-play"
  }), "Run"), /*#__PURE__*/React.createElement(SaveSplitButton, {
    handleClick: onSaveQuery,
    handleSaveQuery: processSave,
    disabled: !selectedDataType || isSaveDisabled,
    queryData: queryData
  }), /*#__PURE__*/React.createElement(StyledSpan, {
    onClick: () => {
      dispatch(pushHideCard(!hideCard));
    }
  }, ' ', hideCard ? /*#__PURE__*/React.createElement("img", {
    src: accordianDown,
    alt: "downArrow"
  }) : /*#__PURE__*/React.createElement("img", {
    src: accordianUp,
    alt: "upArrow"
  }))), /*#__PURE__*/React.createElement(DialogModal, {
    handleSave: processSave,
    queryData: queryData,
    buttonName: buttonValue,
    changeButtonName: changeButtonName
  }));
};

export default RunAndSave;